<DynamicTemplateComponent :template="template"/>


